import {project2BaseUrl } from './remoteClient'

export async function partnersRequest (token){
    return await project2BaseUrl.get('/administration/getEntities',{
        headers: {
            'Authorization': 'Bearer ' + token
    }})
}